import { showRewardedDetailed, isNative } from './applovin_max.js';
import { isRewardedReady, loadRewardedFirstTime } from './first_load_manager.js';
import { AdsConfigService } from './ads_config.js';
import { SessionController } from '../socket_handler/controllers/session_controller.js';
import { NetworkManager } from '../network_manager.js';
import { areAdsBlockedOffline } from './offline_ads.js';

const REWARDED_LOG_TAG = '[ADS_REWARDED]';

export type RewardedShowResult = {
  shown: boolean;
  rewarded: boolean;
  refused: boolean;
  ad_id: string | null;
};

export async function showRewarded(
  placement_id = 'rewarded',
  level = AdsConfigService.getCurrentLevel()
): Promise<RewardedShowResult>
{
  if ( !isNative() || !AdsConfigService.isRewardedPlacementAllowed( placement_id, level ) )
    return { shown: false, rewarded: false, refused: false, ad_id: null };

  if ( areAdsBlockedOffline() )
  {
    console.log( `${REWARDED_LOG_TAG} offline, rewarded blocked`, { placement_id } );
    return { shown: false, rewarded: false, refused: false, ad_id: null };
  }

  const ready = await isRewardedReady();
  if ( !ready )
  {
    console.log( `${REWARDED_LOG_TAG} rewarded not ready, loading...` );
    const loaded = await loadRewardedFirstTime();
    if ( !loaded )
    {
      console.warn( `${REWARDED_LOG_TAG} load failed` );
      return { shown: false, rewarded: false, refused: false, ad_id: null };
    }
  }

  const res = await showRewardedDetailed( placement_id, level );
  if ( res.shown && res.rewarded )
  {
    if ( NetworkManager.isOnline() )
      await SessionController.sendRewardImpressionPerSession();
    else
      void SessionController.sendRewardImpressionPerSession();
  }
  return {
    shown: res.shown,
    rewarded: res.rewarded,
    refused: res.shown && !res.rewarded,
    ad_id: res.ad_id,
  };
}

export async function tryShowRewarded(
  placement_id = 'rewarded',
  level = AdsConfigService.getCurrentLevel()
): Promise<boolean>
{
  return ( await showRewarded( placement_id, level ) ).rewarded;
}
